<template>
  <section>
    <!-- <GsCatelogueForm class="desktopView" v-bind:payload="payload"></GsCatelogueForm> -->
       <v-overlay :value="set_overlay">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
    <userOrderForm class=""></userOrderForm>
  </section>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
// import GsCatelogueForm from "@/components/GsCatelogueForm.vue";
import { loadFile, setLocale, loadLocale } from "../services/firebase";
import userOrderForm from "@/components/userOrderForm";


export default {
  data() {
    return {
      name: "",
      showMessage: false,
      locale: "Deutsch",
      set_overlay: false,
      payload:{}
    };
  },
  props: [],
  components: {
    // GsCatelogueForm,
    userOrderForm,
  },
  mounted() {
    if(window.location.href.split('?')[1]){
      if(window.location.href.split('?')[1].split('=')[1]) this.$i18n.locale=window.location.href.split('?')[1].split('=')[1]
      else  setLocale();
    } else  setLocale();
    this.$store.state.currentFormPos = 0;
  },
  watch: {
    // call again the method if the route changes
    $route: "",
  },
  methods: {
    fetchData() {
      this.set_overlay = true
      // if (this.$route.params.formid) {
      //   loadLocale(this.$route.params.formid, function () {});
      // }
      var state = this.$store.state;
      state.currentFormPos = this.$route.params.formpos;
      // var store = this.$store;
      var elethis = this
      loadFile(
        this.$route.params.formid,
        this.$route.params.formpos,
        state,
        function (error) {
          if (error) {
            //TODO skeleton data
            Vue.nextTick(() => {
              elethis.set_overlay = false
              // store.dispatch("setOverlay", false);
            });
          } else {
            for (var i = 0; i < state.currentForm.catalogue.length; i++) {
              state.currentForm.catalogue[i].qtty = 0;
              state.currentForm.catalogue[i].isOrdered = false;
            }
            Vue.nextTick(() => {
              //controller.resume();
              elethis.set_overlay = false
              // store.dispatch("setOverlay", false);
            });
          }
        }
      );
    }
  },
};
</script>
